export default __webpack_public_path__ + "static/media/006-wireless keyboard.df526532.svg";